export const InfractionFieldMessageMapper: { [key: string]: string } = {
  // WASTE - Record level
  'No SIC code': 'classificationCode',
  'No waste carrier licence': 'carrierLicenceId',
  'No waste carrier name': 'carrierName',
  'No waste facility address': 'facilitySiteAddress',
  'No waste facility operator name': 'facilityOperatorName',
  'No waste facility permit or exemption': 'facilityPermitId'
}
